var _sodipodiNamedview, _defs, _path, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    id: "svg10",
    width: 160,
    height: 160,
    sodipodiDocname: "horizontal_render.svg",
    "inkscapeExport-filename": "logo.svg",
    "inkscapeExport-xdpi": 96,
    "inkscapeExport-ydpi": 96,
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f22834",
    d: "m 154.7781,62.834882 q 1.7,5.97 2.08,9.6 c 0.92,9.01 1.32,20.94 -1.46,30.339998 q -0.16,0.52 -0.7,0.52 H 4.8181057 q -0.26,0 -0.31,-0.26 c -0.65,-2.97 -1.51,-5.849998 -1.73,-8.859998 -0.93,-12.62 -0.63,-22.7 2.9299999,-33.7 7.1900004,-22.14 24.1400004,-41.3 46.3600004,-49.26 2.86,-1.03 5.66,-2.18 8.58,-2.84 11.6,-2.6 21.28,-3.13 32.54,-1.17 29.799994,5.19 53.279994,26.58 61.589994,55.63 z",
    id: "path1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#f22834",
    x: 10.528102,
    y: 111.62489,
    width: 138.86,
    height: 5.2800002,
    rx: 2.6199999,
    id: "rect1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f22834",
    x: 17.828106,
    y: 123.13489,
    width: 124.14,
    height: 4.8400002,
    rx: 1.97,
    id: "rect2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f22834",
    x: 31.578106,
    y: 134.15489,
    width: 96.599998,
    height: 4.7800002,
    rx: 2.26,
    id: "rect3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f22834",
    x: 52.73811,
    y: 145.17488,
    width: 54.580002,
    height: 5.1199999,
    rx: 2.53,
    id: "rect4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.41ac86b65a859b53a1ee82961bf34132.svg";
export { ForwardRef as ReactComponent };